import React from "react";

export default function LoyaltyForm({
  editingId,
  subscription,
  visitNumber,
  setVisitNumber,
  reward,
  setReward,
  rewardType,
  setRewardType,
  minBillAmount,
  setMinBillAmount,
  discountType,
  setDiscountType,
  discountValue,
  setDiscountValue,
  voucherValue,
  setVoucherValue,
  addRule
}) {
  return (
    <div className="card">
      <h2>{editingId ? "✏️ Edit Offers " : "🎁  Create Offers"}</h2>
      {/* <p>Define operational triggers for visitor counters and voucher thresholds below.</p> */}

      <div className="input-group">
        <label>Target Visit Count</label>
        <input
          type="number"
          placeholder="e.g. 4"
          value={visitNumber}
          onChange={(e) => setVisitNumber(e.target.value)}
          disabled={!subscription.active}
        />
      </div>

      <div className="input-group">
        <label>Reward Title Line</label>
        <input
          type="text"
          placeholder="e.g. Complimentary Beverage"
          value={reward}
          onChange={(e) => setReward(e.target.value)}
          disabled={!subscription.active}
        />
      </div>

      <div className="input-group">
        <label>Reward Strategy Type</label>
        <select
          value={rewardType}
          onChange={(e) => setRewardType(e.target.value)}
          disabled={!subscription.active}
        >
          <option value="discount">💸 Direct Invoice Discount</option>
          <option value="voucher">🎁 Redeemable Gift Voucher</option>
        </select>
      </div>

      <div className="input-group">
        <label>Minimum Required Bill Amount (₹)</label>
        <input
          type="number"
          placeholder="e.g. 1500"
          value={minBillAmount}
          onChange={(e) => setMinBillAmount(e.target.value)}
          disabled={!subscription.active}
        />
      </div>

      {rewardType === "discount" && (
        <>
          <div className="input-group">
            <label>Discount Type Mode</label>
            <select
              value={discountType}
              onChange={(e) => setDiscountType(e.target.value)}
              disabled={!subscription.active}
            >
              <option value="percentage">Percentage Value (%)</option>
              <option value="flat">Flat Value Reduction (₹)</option>
            </select>
          </div>

          <div className="input-group">
            <label>{discountType === "percentage" ? "Value Allocation (%)" : "Flat Reduction Amount (₹)"}</label>
            <input
              type="number"
              placeholder={discountType === "percentage" ? "15" : "300"}
              value={discountValue}
              onChange={(e) => setDiscountValue(e.target.value)}
              disabled={!subscription.active}
            />
          </div>
        </>
      )}

      {rewardType === "voucher" && (
        <div className="input-group">
          <label>Voucher Face Value (₹)</label>
          <input
            type="number"
            placeholder="500"
            value={voucherValue}
            onChange={(e) => setVoucherValue(e.target.value)}
            disabled={!subscription.active}
          />
        </div>
      )}

      <button
        className="save-btn"
        onClick={addRule}
        disabled={!subscription.active}
        style={!subscription.active ? { opacity: 0.5, cursor: "not-allowed", background: "#cbd5e1", boxShadow: "none" } : {}}
      >
        {editingId ? "⚡Commit Strategy Changes" : "🚀 Deploy Loyalty Campaign"}
      </button>
    </div>
  );
}